import { render, staticRenderFns } from "./suggest-result-catalog-coffee.vue?vue&type=template&id=7b0bb0d5&"
import script from "./suggest-result-catalog-coffee.vue?vue&type=script&lang=js&"
export * from "./suggest-result-catalog-coffee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports